__webpack_require__.p = "/assets/turbo/50779fe6/universalat/_next/";